<template>
  <SelectableSearch
    :model-value="props.modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    :options="props.options"
    idKey="id"
    labelKey="name"
    :formatter="props.formatter || defaultFormatLabel"
    :getInputLabel="(v) => v?.name ?? ''"
    :placeholder="props.placeholder || 'ユーザ名またはIDで検索'"
    :required="props.required || false"
  />
</template>

<script setup>
import SelectableSearch from './SelectableSearch.vue'

const props = defineProps({
  modelValue: [String, Number, null],
  options: {
    type: Array,
    required: true
  },
  formatter: Function,
  placeholder: String,
  required: Boolean
})

const emit = defineEmits(['update:modelValue'])

const defaultFormatLabel = (v) => `${v.name}（ID: ${v.id}）`
</script>
